import React, {useEffect} from 'react';
import * as Sentry from '@sentry/browser';
import {withAuth} from "../../hoc/Auth";
import Api from "../../Api";
import PaymentsTotalToday from "../../Components/PaymentsTotalToday"
import PaymentsOnMonth from "../../Components/PaymentsOnMonth"
import BalanceWidget from "../../Components/BalanceWidget"
import ProjectsWidget from "../../Components/ProjectsWidget"
import CountryWidget from "../../Components/CountryWidget";
import EventsWidget from "../../Components/EventsWidget";

import EmptyCard from "../../hoc/EmptyCard";

import MpsChart from "../../Components/Charts/MpsChart"
import TopErrorsDiffChart from "../../Components/Charts/TopErrorsDiffChart"

import classes from './styles.module.css'

const Dashboard = withAuth(({token}) => {

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [extendedBalances, setExtendedBalances] = React.useState(null);

    useEffect(() => {

        var api = new Api({token});

        api.getDashboard().then(
            function (r) {
                setData(r);
                setLoading(false);
            }
        );

        api.getMerchantBalances().then(
            function (r) {
                setExtendedBalances(r);
            }
        ).catch(function (err) {
            Sentry.captureException(err);
            // Silently ignore — old balance will show
        });

    }, []);

    return (
        <div className={`${classes.DashboardWrapper} ${classes.FullBleed}`}>
            <div className={classes.Container}>
                <div className={`${classes.FlexRow} ${classes.SummaryRow}`}>
                    <PaymentsTotalToday data={data.today} isLoading={loading}/>
                    <PaymentsOnMonth data={data.total} isLoading={loading}/>
                    <BalanceWidget
                        data={data.balance_total}
                        extendedBalances={extendedBalances}
                        isLoading={loading}
                    />
                </div>

                <div className={classes.FlexRow}>
                    <CountryWidget/>
                </div>

                <div className={classes.FlexRow}>
                    <EmptyCard title="Dashboard.title.errors">
                        <TopErrorsDiffChart/>
                    </EmptyCard>
                    <EmptyCard title="Dashboard.title.paymentSystems">
                        <MpsChart/>
                    </EmptyCard>
                </div>

                <div className={classes.FlexRow}>
                    <ProjectsWidget/>
                </div>

                <div className={classes.FlexRow}>
                    <EventsWidget/>
                </div>
            </div>
        </div>
    )
});

export default Dashboard;



// WEBPACK FOOTER //
// ./src/PagesOfUser/Dashboard/index.js